import VideoUpload from './VideoUpload';

export default VideoUpload;
